'use strict';

define('ui/shell.i18n.en-gb',[], {
	'home': 'Home',
	'policies': 'Policies',
	'watch': 'Watch',
	'devices': 'Devices',
	'myAccount': 'My Account',
	'reporting': 'Reporting',
	'admin': 'Admin',
	'operations': 'Operations',
	'systemMonitoring': 'Sys Monitoring',
	'dispatch': 'Dispatch',
	'userAccounts': 'User Accounts',
	'management': 'Management',
	'imports': 'Imports',
	'developer': 'Developer',
	'fourFiveHome': 'Home',
	'fourFiveReporting': 'Reporting',
	'fourFiveUsers': 'Users',
	'fourFiveAdmin': 'Admin',
	'fourFiveManagement': 'Management',
	'fourFiveImports': 'Imports',
	'prod-label': 'Products',
	'lang-label': 'Language',
	'env-label': 'Environment',
	'shared': { 'logout-button': 'Logout' }
});
